import { FC } from 'react';
import { FormRenderProps } from 'react-final-form';
import { InputField } from '@features/form';
import { Button, Select } from '@shared/UI';
import './AssignPositionForm.scss';
import CloseSingleSecurityDrawerStore from '@widgets/OrderTable/store/account-refresh-store';
import { FaInfoCircle } from 'react-icons/fa';

interface IAssignPositionForm extends FormRenderProps<any> {
    loading: boolean;
    order: any;
}

export const AssignPositionForm: FC<IAssignPositionForm> = (props) => {
    const { loading, handleSubmit, order } = props;

    const validateQuantity = (value: number) => {
        if (value === undefined || value === null || value === 0) {
            if (order?.remainingQuantity > 0) {
                return 'Enter a number greater than 0.';
            } else {
                return 'Enter a number less than 0.';
            }
        }

        const remainingQuantity = order?.remainingQuantity || 0;

        if (remainingQuantity < 0) {
            if (value > 0 || value < remainingQuantity) {
                return `Enter a number less than or equal to ${remainingQuantity}`;
            }
        } else {
            if (value <= 0 || value > remainingQuantity) {
                return `Enter a number greater than 0 and less than or equal to ${remainingQuantity}`;
            }
        }
    };

    const setIsDrawerClosed = CloseSingleSecurityDrawerStore((state) => state.setIsDrawerClosed);
    const userStorage = localStorage.getItem('User');
    let userObject = null;
    userObject = JSON.parse(userStorage ? userStorage : '');

    const handleFormSubmit = (event: React.FormEvent) => {
        event.preventDefault(); // Prevent default form submission

        // Check if required fields are selected
        if (props.errors?.quantity) {
            return; // Stop form submission
        }

        handleSubmit(event); // Proceed with form submission
    };

    return (
        <form
            role='form'
            onSubmit={handleFormSubmit}
            className='assign-position-lot-form'
        >
            <div className='assign-position-lot-form__inputs'>
                <div className='security-div'>
                    <FaInfoCircle className='security-icon' />
                    <div className='security-text'>Security</div> {order?.symbol}
                </div>
                <div className='text'>Account</div>
                <Select
                    allowClear
                    required
                    currentValue={props.values.accountId?.toString()}
                    options={
                        userObject?.subAccounts?.map((subAccount: any) => ({
                            value: subAccount.id,
                            label: `${subAccount.verificationRequest.firstName} ${subAccount.verificationRequest.lastName} - ${subAccount.fdid}`,
                        })) || []
                    }
                    placeholder='Select Account'
                    onSelect={(value) => props.form.change('accountId', value)}
                    className='wide-field'
                />
                <div className='text'>Quantity</div>
                <InputField
                    required
                    name='quantity'
                    placeholder='Enter Quantity'
                    label='Quantity'
                    infoTooltip='Quantity'
                    type='number'
                    validate={validateQuantity}
                />
                {props.errors?.quantity && props.touched?.quantity && (
                    <div className='error-message'>{props.errors.quantity}</div>
                )}
                <div className='text-disable'>Price (order avg price)</div>
                <InputField
                    name='AveragePrice'
                    placeholder={order?.updatedPrice}
                    label='AveragePrice'
                    infoTooltip='Average Price'
                    type='number'
                    value={order?.updatedPrice}
                    disabled={true}
                />
            </div>
            <div className='flex-only'>
                <Button
                    loading={loading}
                    type='submit'
                    disabled={!order?.securityId}
                >
                    Assign
                </Button>
                <Button
                    type='button'
                    onClick={() => setIsDrawerClosed(true)}
                    className='buttons-cancel-assign'
                >
                    Cancel
                </Button>
            </div>
        </form>
    );
};
